import {Component, ViewChild} from '@angular/core';
import {Jornada} from "../../../../domain/Jornada";
import {ModalController, PopoverController} from "@ionic/angular";
import {Monitoramento} from "../../../../domain/Monitoramento";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";
import {IsNull} from "typeorm";
import {IRepository} from "../../../../services/persist/IRepository";
import {EditMonitoramentoComponent} from "../../monitoramento/edit/edit-monitoramento.component";
import {Periodo} from "../../../../domain/Periodo";
import {GpsService} from "../../../../services/gps.service";
import {TrackingComponent} from "../../../tracking/tracking.component";
import {Especime} from "../../../../domain/Especime";
import {EditEspecimeComponent} from "../../especime/edit/edit-especime.component";
import {Utils} from "../../../../services/Utils";
import {EnumSincronizacao} from "../../../../domain/EnumSincronizacao";
import {LocalRepository} from "../../../../services/persist/LocalRepository";
import {Arquivo} from "../../../../domain/Arquivo";
import {SQLiteService} from "../../../../services/sqlite.service";
import {MetodoAmostragem} from "../../../../domain/MetodoAmostragem";
import {PopoverComponent} from "../popover/popoper.component";

@Component({
  selector: 'app-jornada',
  templateUrl: './jornada.component.html',
  styleUrls: ['./jornada.component.scss'],
})
export class JornadaComponent {
  jornada?: Jornada
  repo: IRepository<Jornada>
  duracao?: string
  contagem?: number
  _fim = new Date()
  isAlertOpen = false
  exibirEspecime = false
  showHelp = false
  @ViewChild(TrackingComponent)
  track: TrackingComponent
  alertButtons = [
    {
      text: 'Cancelar',
      role: 'cancel',
      handler: () => {
        this.isAlertOpen = false
      },
    },
    {
      text: 'OK',
      role: 'confirm',
      handler: () => {
        this.isAlertOpen = false
        this.fecharJornada().then()
      },
    },
  ];

  get helpButton(){
    return this.showHelp ? "notifications-circle-outline" : "notifications-off-circle-outline"
  }

  changeHelp(){
    this.showHelp = !this.showHelp
  }

  showEspecime(valor: boolean){
    this.exibirEspecime = valor
  }

  header(met: MetodoAmostragem, mon: Monitoramento): string {
    const textos = []
    textos.push(mon.projeto.nome)
    if(mon.campanha)  textos.push(mon.campanha.nome)
    if(mon.local) textos.push(mon.local.nome)
    // textos.push(met.grupos.join(","))
    textos.push(met.nome)
    return textos.join(" - ")
  }

  async exibir(met: MetodoAmostragem, mon: Monitoramento, e: Event){
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: {
        projeto: mon.projeto.nome,
        campanha: mon.campanha?.nome,
        local: mon.local?.nome,
        grupos: met.grupos.join(","),
        metodo: met.nome
      },
      event: e
    });

    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log(`Popover dismissed with role: ${role}`)

  }

  especiesByMetodo(monitor: Monitoramento, metodo: MetodoAmostragem): Especime[]{
    // console.log(monitor.especimes)
    // console.log(metodo)
    return monitor.especimes?.filter(e=> e.metodoAmostragem.id == metodo.id)
  }

  constructor(private modalCtrl: ModalController,
              private ds: FaunaDataSource,
              protected gps: GpsService,
              private sqlite: SQLiteService,
              private popoverController: PopoverController) {
    this.repo = ds.getRepository(Jornada)
    setInterval(() => {
      this._fim = new Date();
      this.contagem = this.gps.tracking?.length || 0
      const ms = this.calculaDuracao()
      this.duracao = this.msToHuman(ms)
      // this.track.updateMapa()
    }, 1000);
    // this.loadLeafletMap()
  }

  openAlerta() {
    this.isAlertOpen = true
  }

  async getOrCreateJornada() {
    this.jornada = await this.repo.findOne({
      where: {fim: IsNull()},
      relations: ['monitoramentos', 'monitoramentos.projeto', 'monitoramentos.campanha',"monitoramentos.especimes.metodoAmostragem",
        'monitoramentos.metodos','monitoramentos.especimes', 'monitoramentos.especimes.arquivos', 'monitoramentos.especimes.taxon']
    })
    if (!this.jornada) {
      this.jornada = new Jornada()
      this.jornada.situacao = EnumSincronizacao.INCOMPLETO
      this.jornada.agencia_sigla = localStorage.getItem("agencia")
      await this.repo.save(this.jornada)
    }
    console.log(this.jornada)
    await this.sqlite.saveToStore()
  }

  async iniciarJornada() {
    this.jornada.inicio = new Date()
    this.jornada.periodos = [new Periodo()]
    const mons = this.jornada.monitoramentos
    //necessário para envitar o problema cyclic dependency que só ocorre no androoid
    this.jornada.monitoramentos = []
    console.log('antes de salvar')
    await this.repo.save(this.jornada)
    console.log('salvou jornada')
    this.jornada.monitoramentos = mons
    this.jornada.monitoramentos.forEach(m => m.inicio = new Date())
    await this.repo.save(this.jornada)
    console.log("salvou jornada de novo")
    console.log(this.jornada)
    await this.gps.iniciar()
    await this.sqlite.saveToStore()
  }

  async fecharJornada() {
    const ultimoPeriodo = this.jornada.periodos[this.jornada.periodos.length - 1]
    if (!this.jornada.pausado) {
      ultimoPeriodo.fim = new Date()
    }
    const coordinates = this.gps.tracking
    if (coordinates?.length == 1) {//Se tiver somente uma coordenada adiciona mais uma pra fazer a linha
      coordinates?.push(coordinates[0])
    }
    this.jornada.fim = ultimoPeriodo.fim
    this.jornada.pontos = this.gps.lineString
    this.jornada.situacao = EnumSincronizacao.ENVIAR
    delete this.jornada.pausado
    this.jornada.duracao = this.calculaDuracao() / 1000
    for (const m of this.jornada.monitoramentos) {
      m.fim = new Date()
      m.situacao = EnumSincronizacao.ENVIAR
      if(m.especimes &&  m.especimes?.length > 0) {
        const repoEsp = this.ds.getRepository(Especime)
        for (const e of m.especimes) {
          e.situacao = EnumSincronizacao.ENVIAR
          await repoEsp.save(e)
          if(e.arquivos && e.arquivos.length > 0){
            const repoArq = this.ds.getRepository(Arquivo)
            for (const a of e.arquivos) {
              a.situacao = EnumSincronizacao.ENVIAR
              await repoArq.save(a)
            }
          }
        }
      }
    }
    await this.repo.save(this.jornada)
    await this.gps.parar()
    console.log('forçando atualização da página')
    await this.getOrCreateJornada()
    this.track.clearAll();
    await this.sqlite.saveToStore()
  }

  async pausarJornada() {
    const jorn = this.jornada
    jorn.pausado = true
    const ultimoPeriodo = jorn.periodos[jorn.periodos.length - 1]
    ultimoPeriodo.fim = new Date()
    await this.repo.save(jorn)
    await this.gps.pausar()
    await this.sqlite.saveToStore()
  }

  async retomarJornada() {
    const jorn = this.jornada
    jorn.pausado = false
    jorn.periodos.push(new Periodo())
    await this.repo.save(jorn)
    await this.gps.iniciar()
    await this.sqlite.saveToStore()
  }

  async addEspecime(mon: Monitoramento, met: MetodoAmostragem) {
    const esp = new Especime()
    esp.dataHora = Utils.dataHoraAtual()
    esp.agencia_sigla = localStorage.getItem("agencia")
    esp.monitoramento = mon
    esp.metodoAmostragem = met
    esp.situacao = EnumSincronizacao.INCOMPLETO
    esp.arquivos = []

    const modal = await this.modalCtrl.create({
      component: EditEspecimeComponent,
      componentProps: {
        entidade: esp,
        dialogo: true,
        novo: true
      }
    })
    await modal.present()
    const {data, role} = await modal.onWillDismiss()
    if (role == 'confirm') {
      if(!mon.especimes) mon.especimes=[]
      mon.especimes.push(data)
      const repo = this.ds.getRepository(Especime)
      esp.monitoramento = mon
      await repo.save(esp)
      this.track.addIndividuos(esp)
    }
    await this.sqlite.saveToStore()
  }

  async showIndividuos(esp: Especime) {
    const modal = await this.modalCtrl.create({
      component: EditEspecimeComponent,
      componentProps: {
        entidade: esp,
        dialogo: true,
        novo: false
      }
    })
    await modal.present()
  }


  async addMonitoramento() {
    const mon = new Monitoramento()
    mon.agencia_sigla = localStorage.getItem("agencia")
    mon.inicio = new Date()
    mon.jornada = this.jornada
    mon.situacao = EnumSincronizacao.INCOMPLETO

    const modal = await this.modalCtrl.create({
      component: EditMonitoramentoComponent,
      componentProps: {
        entidade: mon,
        dialogo: true,
        novo: true
      }
    })
    await modal.present()
    const {data, role} = await modal.onWillDismiss()
    if (role == 'confirm') {
      const repo = this.ds.getRepository(Monitoramento)
      if (!this.jornada?.monitoramentos) this.jornada.monitoramentos = []
      await repo.save(data)
      this.jornada.monitoramentos.push(data)
      await this.repo.save(this.jornada)
    }
    await this.sqlite.saveToStore()
  }

  zeroPad(num: number, places: number): string {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }

  msToHuman(duration: number): string {
    const seconds = parseInt(String((duration / 1000) % 60))
    const minutes = parseInt(String((duration / (1000 * 60)) % 60))
    const hours = parseInt(String((duration / (1000 * 60 * 60))));
    let resp = ""
    if (hours > 0) resp += hours + ":"
    if (minutes > 0) resp += this.zeroPad(minutes, 2) + ":"
    if (seconds > 0) resp += this.zeroPad(seconds, 2)
    return resp
    // return hours + ": " + minutes + "min " + seconds + "sec ";
  }

  calculaDuracao() {
    if (this.jornada.inicio) {
      let duracao = 0
      this.jornada.periodos.forEach(p => {
        const fim = p.fim ? new Date(p.fim) : new Date()
        const inicio = new Date(p.inicio)
        duracao += fim.getTime() - inicio.getTime()
      })
      return duracao
    } else {
      return 0
    }
  }

  ionViewDidEnter() {
    this.getOrCreateJornada().then(_=>{
      console.log(this.jornada)
      this.track.jornada = this.jornada
      this.track.ionViewDidEnter()
    })
  }

}

